import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import TauriImage from '../../../TauriImage/TauriImage';
import './FinishSessionModal.css';
import SignatureDrawing from './SignatureDrawing/SignatureDrawing';
import Camera from './Camera/Camera';
import { addRecord, getAll, getNextId, getRecordById, updateRecord } from '../../../../localDB';
import TauriLoader2 from '../../../TauriLoader2/TauriLoader2';
import { SyncStatusMap } from '../../../../visualizations/visualizations';

const FinishSessionModal = ({ show, onHide, id, onFinishSession, isFinishing }) => {
    const dateNow = new Date();

    const [mode, setMode] = useState('sign');
    const [sessionData, setSessionData] = useState(null);
    const [institutionData, setInstitutionData] = useState(null);
    const [customer, setCustomer] = useState(null);
    const [sessionItem, setSessionItem] = useState([]);
    const [showMore, setShowMore] = useState(false); // state to control showing more items
    const [signatureImage, setSignatureImage] = useState(null);
    const [captureImage, setCaptureImage] = useState(null);

    const storedPermission = localStorage.getItem("permission");
    const permission = JSON.parse(atob(storedPermission));

    const fetchData = async () => {
        try {
            const session = await getRecordById("session", id);
            const institution = await getRecordById("institution", session?.InstitutionID)
            const customer = await getRecordById("customer", session?.AccountID)
            const si = await getAll("sessionItems");
            const item = await getAll("item");
            const unit = await getAll("unit");
            const sessItem = si.filter((a) => a.SessionID === id && a.SyncStatus !== SyncStatusMap.done);

            const sessionItemsWithNames = sessItem.map((a) => {
                const b = item.find((i) => i.ID === a.ItemID);
                const c = unit.find((u) => u.ID === a.UnitID);

                return {
                    ...a, // Keep all the original session item data
                    ItemLongName: b ? b.LongName : '', // Add item long name
                    UnitDesc: c ? c.Description : '', // Add unit name
                };
            });

            setSessionData(session);
            setInstitutionData(institution);
            setCustomer(customer);
            setSessionItem(sessionItemsWithNames);

        } catch (error) {
            console.log("Error Fetching!");
        }
    }

    const handleCapture = (img) => {
        setCaptureImage(img);
    };

    const handleFinishSession = () => {
        onFinishSession(captureImage, signatureImage, false);
    };

    const handleFinishSessionWithNotes = () => {
        onFinishSession(captureImage, signatureImage, true);
    }

    useEffect(() => {
        setSignatureImage(null);
        setCaptureImage(null);
        setMode("sign");
        fetchData();
    }, [id])

    useEffect(() => {
        setShowMore(false);
        fetchData();
    }, [show])

    const groupedItems = sessionItem.reduce((acc, item) => {
        if (!acc[item.ItemID]) {
            acc[item.ItemID] = {
                ItemLongName: item.ItemLongName,
                units: [],
            };
        }
        acc[item.ItemID].units.push({
            UnitDesc: item.UnitDesc,
            Executed: item.Executed,
        });
        return acc;
    }, {});

    // Get the first 3 items and the rest
    const groupedItemsArray = Object.entries(groupedItems);
    const remainingItems = groupedItemsArray.slice(3);

    return (
        <>
            <Modal className='finish-session-modal' show={show} onHide={onHide} size="lg" centered>
                <Modal.Header>
                    Finish Session
                </Modal.Header>
                <Modal.Body>
                    {permission?.coverage?.samples && (
                        <div className='sample-container mb-3'>
                            <div className="sample-title">SAMPLES</div>
                            {/* Render first 3 items initially */}
                            {(showMore ? groupedItemsArray : groupedItemsArray.slice(0, 3)).map(([itemID, { ItemLongName, units }]) => (
                                <div key={itemID} className="sample-details mb-2">
                                    <div className="item-header d-flex align-items-center">
                                        <TauriImage localImage={"/Images/circle-check.svg"} className={"check"} alt='icon' />
                                        <div className="item-long-name">{ItemLongName}</div>
                                        <div className="units d-flex flex-wrap">
                                            {units.slice(0, 4).map((unit, index) => (
                                                <div key={index} className="unit-detail mr-3">
                                                    <span>, </span><span className='session-quantity'>{unit.Executed}</span> {unit.UnitDesc}
                                                </div>
                                            ))}
                                            {units.length > 4 && (
                                                <div className="unit-detail text-muted ms-1">
                                                    + {units.length - 4} more
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}

                            {/* Show more button if there are remaining items */}
                            {groupedItemsArray.length > 3 && !showMore && (
                                <div className='btn-more' onClick={() => setShowMore(true)}>
                                    + {remainingItems.length} items more
                                </div>
                            )}
                        </div>
                    )}

                    {/* Signature or photo */}
                    <div className="preview-container d-flex flex-column mb-2">
                        {mode === 'photo' &&
                            <Camera onCapture={handleCapture} />
                        }
                        {mode === 'sign' &&
                            <div className="preview-content signature">
                                <SignatureDrawing onSignatureChange={setSignatureImage} Signature={signatureImage} />
                            </div>
                        }
                        <div className="description">
                            {customer?.Name}
                        </div>
                    </div>

                    <div className="sess-details d-flex justify-content-between align-items-end">
                        <div>
                            <div className="sess-date">
                                {dateNow.toLocaleString("en-US", {
                                    timeZone: "Asia/Manila",  // ✅ Ensures it's always UTC+8
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                    hour: "numeric",
                                    minute: "2-digit",
                                    hour12: true,
                                }).replace(",", "").replace("AM", "am").replace("PM", "pm")}
                            </div>
                            <div className='sess-inst'>{institutionData?.name}</div>
                        </div>
                        {/* {sessionData?.JointCallAgentID && (
                            <div className="sess-joint">
                                <span>Joint Call with {agentInfo.Name}</span>
                            </div>
                        )} */}

                    </div>
                </Modal.Body>

                <Modal.Footer className="justify-content-between">
                    <div className="d-flex gap-2">
                        <TauriImage localImage={"/Images/camera.svg"} className={"camera"} alt='icon' onClick={() => setMode('photo')} color={"#3695E4"} />
                        <TauriImage localImage={"/Images/pen.svg"} className={"sign"} alt='icon' onClick={() => setMode('sign')} color={"#3695E4"} />
                    </div>
                    <div className="d-flex gap-2">
                        <Button className='btn-addnotes d-flex' onClick={handleFinishSessionWithNotes} disabled={isFinishing}>
                            {isFinishing && (
                                <TauriLoader2 width="1.2rem" height="1.2rem" borderwidth="0.2rem" color="#FFF" />
                            )}
                            <span className="ms-2 text-nowrap">FINISH AND ADD NOTES</span>
                        </Button>
                        <Button className="btn-finish-session d-flex" onClick={handleFinishSession} disabled={isFinishing}>
                            {isFinishing && (
                                <TauriLoader2 width="1.2rem" height="1.2rem" borderwidth="0.2rem" color="#FFF" />
                            )}
                            <span className="ms-2 text-nowrap">Finish Session</span>
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default FinishSessionModal;
